import React from 'react';
import CardBrowser from '../components/CardBrowser';

export default function Cards({ cards = [] }) {
  // Ensure cards is always an array
  const safeCards = Array.isArray(cards) ? cards : [];

  return (
    <div className="container py-8">
      <div className="mb-8 text-center">
            <h1 className="text-4xl font-display font-bold text-foreground mb-2">Riftbound Cards</h1>
        <p className="text-muted-foreground">Browse and search through all available cards</p>
      </div>

      <CardBrowser cards={safeCards} />
    </div>
  );
}